<template>
  <AssetTypeVideo />
  <div
    class="container h-100 d-flex align-items-center justify-content-center z-2"
  >
    <div class="row mobile align-content-between g-0">
      <div
        class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header"
      >
        <a href="#" class="m-auto"
          ><img src="/img/ui-theme/logo.png" class="logo"
        /></a>
        <img src="/img/ui-theme/call.png" height="28" />
      </div>
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              :to="{
                name: 'VideoView',
                params: {
                  guid: '054dc466-7c35-4644-b845-1f61d7b1d9eb',
                  collectionId: '365149',
                },
              }"
              class="btn-theme-menu mb-2 border-top-right"
            >
              The Palms Cinematic
            </router-link>
            <router-link
              :to="{
                name: 'VideoView',
                params: {
                  guid: 'cb08c948-2f42-4017-8d3f-0e0db06b667e',
                  collectionId: '365149',
                },
              }"
              :class="[
                'btn-theme-menu',
                'mb-2',
                {
                  'border-bottom-left': index === assetTypes.length - 1,
                  'border-top-right': index === 0,
                },
              ]"
            >
              Exterior Video
            </router-link>

            <template v-for="(asset, index) in assetTypes" :key="asset.Guid">
              <router-link
                v-if="asset.LinkName === 'type-c-walkthrough'"
                :to="{
                  name: 'AssetType',
                  params: {
                    assetType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.panoramasIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>
              <!-- Panorama links -->
              <router-link
                v-if="asset.LinkName === 'type-c-360-tour'"
                :to="{
                  name: 'AssetType',
                  params: {
                    assetType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.panoramasIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>

              <!-- Renders links -->
              <router-link
                v-if="
                  asset.LinkName === 'renders' || asset.LinkName === 'range'
                "
                :to="{
                  name: asset.ComponentName,
                  params: {
                    assetType: 'type1',
                    viewType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.rendersIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>

              <!-- Floorplans links -->
              <router-link
                v-if="asset.LinkName === 'floorplans'"
                :to="{
                  name: asset.ComponentName,
                  params: {
                    assetType: 'type1',
                    viewType: asset.LinkName,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                <!-- <img :src="theme.floorplansIcon" :alt="asset.ObjectName" class="me-3"> -->
                {{ asset.ObjectName }}
              </router-link>
            </template>
          </div>
        </div>
      </div>

      <TypeBotNav />
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import AssetTypeVideo from "@/components/AssetTypeVideo.vue";
import TypeTopNav from "@/components/TypeTopNav.vue";
import TypeBotNav from "@/components/TypeBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetType",

  components: {
    AssetTypeVideo,
    TypeTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      componentName: "AssetView",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/" + "type1" + "/"
      ),
      assetOrder: null,
    };
  },
  mounted() {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });

        // Assign type menu array
        this.assetOrder = this.theme.type1MenuOrder;

        // Sort array
        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.assetOrder,
          },
        });
        console.log(menuItems);
        this.assetTypes = customMenu;
      })
      .catch((error) => {
        console.log(error);
      }),
      // api call get video collection details

      BunnyNetService.getCollections(this.theme.videoLibraryId, "type1")
        .then((response) => {
          this.collection = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
  },
  setup() {
    // load global config
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
